import ProductAttributeColoursApiV2 from 'api/v2/admins/product-attribute-colours-api-v2'
import ReactMultiSelectSearchField from 'components/molecules/react-multiselect-search-field'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'

const propTypes = {
  name     : PropTypes.string,
  label    : PropTypes.string,
  required : PropTypes.bool
}

/**
 * Allow multi select options from particular Product Colour Filter
 * Only to be used within a Formik component
 * @param {string} code - Product Attribute code
 * @param {string} name - Field name in the formik bag
 * @param {string} label - Field label
 * @param {bool} required - Required badge will show if it set true
 */
const ProductColourFilterMultiSelectField = ({
  name,
  label,
  required,
  ...props
}) => {
  const [ options, setOptions ]     = useState([])
  const [ isLoading, setIsLoading ] = useState(true)

  useEffect(() => {
    if (options.length > 0) return

    ProductAttributeColoursApiV2.getFilter({})
      .then((response) => {
        const options          = response.data
        const formattedOptions = formatOptions(options)

        setOptions(formattedOptions)
        setIsLoading(false)
      })
      .catch(() => {
        alert('Failed: Get filter colours')
      })
  }, [ options.length ])


  /**
   * Format options to proper structure for react-select
   * @param {array} options - list of option
   */
  const formatOptions = (options) => options.map((option) => ({
    value : option.id,
    label : option.label
  }))


  return (
    <ReactMultiSelectSearchField
      name={ name }
      label={ label }
      required= { required }
      isLoading={ isLoading }
      dataList={ options }
      { ...props }
    />
  )
}

ProductColourFilterMultiSelectField.propTypes = propTypes

export default ProductColourFilterMultiSelectField
